import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex, Modal, ModalProps, Spin, Typography } from 'antd';

import FailIcon from 'assets/images/icons/fail.svg?react';
import SuccessIcon from 'assets/images/icons/success.svg?react';
import { useAddWithdrawalMutation } from 'entities/Transaction';
import { EWithdrawalStatuses, IWithdrawal } from 'entities/Transaction/model/types';
import { useCommonSlice } from 'shared/hooks';

import styles from './Withdrawal.module.scss';

interface IWithdrawalProps extends ModalProps {
	withdrawal?: IWithdrawal;
	currency: string;
}

export const Withdrawal: FC<IWithdrawalProps> = ({ withdrawal, currency, ...props }) => {
	const { t } = useTranslation();
	const { currenciesMap } = useCommonSlice();
	const [addWithdrawal] = useAddWithdrawalMutation();

	return (
		<Modal {...props} footer={null}>
			<Flex vertical align="center" gap={24} className={styles.withdrawal}>
				{withdrawal?.status === EWithdrawalStatuses.IN_PROGRESS && <Spin size="large" style={{ padding: 16 }} />}
				{withdrawal?.status === EWithdrawalStatuses.SUCCESS && <SuccessIcon />}
				{withdrawal?.status === EWithdrawalStatuses.FAILED && <FailIcon />}

				<Typography.Title level={3} style={{ margin: 0 }}>
					{withdrawal?.status === EWithdrawalStatuses.IN_PROGRESS && t('Перевод средств на Affilead Wallet')}
					{withdrawal?.status === EWithdrawalStatuses.SUCCESS && t('Перевод средств завершен')}
					{withdrawal?.status === EWithdrawalStatuses.FAILED && t('Денежные средства не были переведены')}
				</Typography.Title>

				<Typography.Text type="secondary" style={{ fontSize: 16 }}>
					{withdrawal?.status === EWithdrawalStatuses.IN_PROGRESS &&
						t(
							'Осуществляется перевод средств на ваш кошелек для дальнейшего вывода. Обычно это занимает меньше минуты, поэтому, пожалуйста, оставьте это окно открытым. Спасибо. ',
						)}
					{withdrawal?.status === EWithdrawalStatuses.SUCCESS &&
						`${withdrawal.amount || 0} ${currenciesMap[currency] || currency} ${t('доступны для вывода на Affiliead Wallet.')}`}
					{withdrawal?.status === EWithdrawalStatuses.FAILED &&
						t(
							'Это может быть связано с ошибкой или прерыванием процесса перевода. Пожалуйста, повторите попытку или обратитесь в нашу службу поддержки.',
						)}
				</Typography.Text>

				<Button
					type="primary"
					disabled={
						!(withdrawal?.status === EWithdrawalStatuses.SUCCESS || withdrawal?.status === EWithdrawalStatuses.FAILED)
					}
					href={withdrawal?.status === EWithdrawalStatuses.FAILED ? undefined : withdrawal?.payment_system_account_url}
					onClick={withdrawal?.status === EWithdrawalStatuses.FAILED ? () => addWithdrawal() : undefined}>
					{withdrawal?.status === EWithdrawalStatuses.FAILED
						? t('Повторить перевод')
						: t('Вывести средства через Affilead Wallet')}
				</Button>
			</Flex>
		</Modal>
	);
};
